interface Topic {
  label: string;
  count: string;
  hot: boolean;
}

const topics: Topic[] = [
  { label: '娱乐圈最新爆料', count: '128.6万', hot: true },
  { label: '网红主播翻车', count: '96.3万', hot: true },
  { label: '明星恋情实锤', count: '85.1万', hot: true },
  { label: '社会热点追踪', count: '72.8万', hot: false },
  { label: '综艺节目内幕', count: '68.4万', hot: false },
  { label: '年度大瓜合集', count: '59.7万', hot: true },
  { label: '短视频精彩片段', count: '54.2万', hot: false },
  { label: '影视剧吐槽', count: '48.9万', hot: false },
  { label: '直播圈大事件', count: '43.6万', hot: false },
  { label: '国外热搜搬运', count: '39.1万', hot: false },
];

export default function TopicsSection() {
  return (
    <section id="topics" className="w-full py-16 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <h2 className="font-heading text-2xl md:text-3xl text-foreground-900 text-center mb-2">热门话题</h2>
        <p className="text-foreground-500 text-sm text-center mb-10">全网最热吃瓜话题实时追踪，数据每小时更新</p>
        <div className="flex flex-wrap justify-center gap-3">
          {topics.map((topic) => (
            <a
              key={topic.label}
              href="#topics"
              className={`inline-flex items-center gap-2 px-4 py-2.5 rounded-full text-sm font-medium transition-all duration-200 cursor-pointer whitespace-nowrap ${
                topic.hot
                  ? 'bg-primary-100 text-primary-700 hover:bg-primary-200 border border-primary-200'
                  : 'bg-background-50 text-foreground-600 hover:bg-background-200 border border-background-200'
              }`}
            >
              {topic.hot && (
                <span className="flex-shrink-0 w-4 h-4 flex items-center justify-center">
                  <i className="ri-fire-line text-xs text-accent-500"></i>
                </span>
              )}
              <span>{topic.label}</span>
              <span className={`text-xs ${topic.hot ? 'text-primary-500' : 'text-foreground-400'}`}>
                {topic.count}
              </span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}